export default "__VITE_ASSET__DAPIJGw5__"